module.exports = __webpack_public_path__ + "static/img/cr_open_bg.b2d34734.png";